module.exports = __webpack_public_path__ + "img/tg-1.80a793f4.png";